import z from "zod";

const LoginSchema = z.object({
  email: z
    .string()
    .trim()
    .min(1, "メールアドレスを入力してください。")
    .refine((val) => z.email().safeParse(val).success, {
      message: "メールアドレスは無効な形式です。",
    })
    .max(255, "メールアドレス/パスワードは半角255文字以下で入力してください。"),
  password: z
    .string()
    .trim()
    .min(1, "パスワードを入力してください。")
    .min(8, "パスワードは8文字以上で入力してください")
    .max(255, "パスワードは255文字以内で入力してください"),
  rememberMe: z.boolean(),
});

export { LoginSchema };
